import { getMetadataFromUrl } from "../../data";
import __styles from "./style.module.scss";
static const { header, link } = __styles;

<const/{ properName, componentUrls }=getMetadataFromUrl($global.url.pathname)>
export interface Input {
  header?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}
<div class=header>
  <${input.header || "h1"}>${properName} Component</>
</div>
